"use client";
import { forwardRef, type ReactNode } from "react";

import { PortalScopeContext } from "./PortalScopeContext";

export interface EdtechProviderProps {
  children: ReactNode,
  name: string,
  className?: string,
}

export const EdtechProvider = forwardRef<HTMLDivElement, EdtechProviderProps>(({
  children,
  name,
  className,
}, ref) => {
  const scopeClass = `edtech-${name}`;
  const classes = [ scopeClass, className ].filter(Boolean).join(" ");

  return (
    <PortalScopeContext.Provider value={scopeClass}>
      <div
        ref={ref}
        className={classes}
      >
        {children}
      </div>
    </PortalScopeContext.Provider>
  );
});

EdtechProvider.displayName = "EdtechProvider";
